import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { postAuth } from "../auth/postAuth";
import "./LoginPage.css";

export default function ViewAsPage() {
  const [params] = useSearchParams();
  const code = (params.get("code") || "").trim();
  const { startViewAs } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const startViewAsRef = useRef(startViewAs);
  startViewAsRef.current = startViewAs;

  useEffect(() => {
    let cancelled = false;

    async function redeem() {
      if (!code) {
        setError("This view-as link is missing its code. Start again from control.");
        return;
      }
      try {
        const data = await postAuth("/auth/view-as.php", { code });
        if (cancelled) return;
        startViewAsRef.current(data);
        navigate("/", { replace: true });
      } catch (err) {
        if (!cancelled) {
          setError(err.message || "Could not open MyData as this user.");
        }
      }
    }

    redeem();
    return () => {
      cancelled = true;
    };
  }, [code, navigate]);

  return (
    <div className="tm-login-shell tm-login-shell--desktop-offset">
      <div className="tm-login-main">
        <div className="tm-login-card">
          <h1 className="tm-login-title">Opening MyData</h1>
          {error ? (
            <div className="tm-login-error">{error}</div>
          ) : (
            <p className="tm-login-subtitle">Signing in to the selected account…</p>
          )}
        </div>
      </div>
    </div>
  );
}
